import { useState } from "react";
import { X } from "lucide-react";
import { fetchKanbanData } from "../../store/slices/kanbanSlice";
import { RootDispatch } from "../../store";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import { addStatusColumn } from "../../store/slices/statusColumnSlice";
import Button, { ButtonType } from "../Assets/Button";

interface AddColumnModalProps {
  isOpen: boolean;
  onClose: () => void;
  onColumnAdded: (data: any) => void;
}

export default function AddColumnModal({
  isOpen,
  onClose,
  onColumnAdded,
}: AddColumnModalProps) {
  const [columnTitle, setColumnTitle] = useState("");
  const dispatch: RootDispatch = useDispatch();

  const addColumn = async () => {
    if (!columnTitle.trim()) {
      toast.error("Column title cannot be empty");
      return;
    }

    try {
      const newColumn = await dispatch(addStatusColumn(columnTitle));
      onColumnAdded(newColumn);
      dispatch(fetchKanbanData({}));
      setColumnTitle("");
      onClose();
    } catch (error) {
      alert("Error adding column");
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 p-4">
      <div className="bg-white  p-5 rounded-lg shadow-lg w-full max-w-72  sm:max-w-lg md:max-w-xl">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-sm sm:text-xl font-semibold">Add Column</h2>
          <button
            onClick={onClose}
            className="text-gray-600 hover:text-gray-800"
          >
            <X size={20} />
          </button>
        </div>

        <input
          type="text"
          value={columnTitle}
          onChange={(e) => setColumnTitle(e.target.value)}
          placeholder="Enter column title"
          className="w-full text-sm md:text-lg p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all"
        />

        <Button
          type={ButtonType.Submit}
          onClick={addColumn}
          className="mt-4 text-xs md:text-sm w-full"
        >
          Add Column
        </Button>
      </div>
    </div>
  );
}
